module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h2', [_vm._v("Behöver du mer än " + _vm._s(_vm.params.addon.plural[0] || 'en') + " " + _vm._s(_vm.params.addon.plural[1] || _vm.params.addon.arttext) + "?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.params.addon.plural[0] || 'En') + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.plural[2] || _vm.params.addon.arttext))]), _vm._v(" finns alltid i boendet, här lägger du till ytterligare en eller flera "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.plural[3] || _vm.params.addon.arttext))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "small",
    on: {
      "click": _vm.click
    }
  }, [_vm._v("Ja, lägg till")]), _vm._v(" "), _c('button', {
    staticClass: "small white border",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Nej, det räcker med " + _vm._s(_vm.params.addon.plural[0] || 'en'))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8eb5b02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/IncludedInPriceModal.vue
// module id = 1030
// module chunks = 0